import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat6-icon',
  templateUrl: './communication-chat6.component.html'
})
export class CommunicationChat6Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
